import React, { useState, useEffect } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import KeyboardBackspace from '@material-ui/icons/KeyboardBackspace';

import SideMenu from './SideMenu'


const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },  
  title: {
    flexGrow: 1,
  },
}));

const getTitle = (pathname) => {
  const titles = {
    '': 'Bibliotecas UFRN',
    'libraries': 'Bibliotecas do SISBI',
    'search': 'Buscar',
    'search-repositories': 'Buscar',
    'search-result': 'Resultados da busca',
    'item': 'Material',
    'item-details': 'Detalhes do material',
    'location': 'Localização do material',
    'copies': 'Exemplares',
    'bookmarks': 'Favoritos',
    'recent-searches': 'Buscas recentes',
    'library-detail': 'Detalhes da biblioteca',
    'about': 'Sobre',
  }
  const path = pathname.split('/')[1]
  return titles[path] || titles['']
}

export default function TopBar(props) {
  const classes = useStyles();
  const [sideMenuState, setSideMenuState] = useState(false);
  const [titleState, setTitleState] = useState();

  useEffect(() => {
    const title = getTitle(props.location.pathname)
    setTitleState(title)    
  }, [props.location.pathname])

  const openSideMenu = () => e => {
    window.history.pushState({openMenu: true}, "", window.location.hash)
    setSideMenuState(true)
  }

  const closeSideMenu = () => e => {
    setSideMenuState(false)
    const state = window.history.state
    if(state && state.openMenu && sideMenuState) { window.history.back() }
  }

  window.onpopstate = () => setSideMenuState(false)

  return (
    <>
      <AppBar position="static">
        <Toolbar>
            {props.location.pathname === '/' || window.history.length === 1 ?
              (
                <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="Menu" onClick={openSideMenu()}>
                  <MenuIcon />
                </IconButton>
              ) : (
                <IconButton edge="start" color="inherit" aria-label="Menu" onClick={ () => window.history.back() }>
                  <KeyboardBackspace />
                </IconButton>
              )
            }
            <Typography variant="h6" className={classes.title}>
              {titleState}
            </Typography>
        </Toolbar>
      </AppBar>
      <SideMenu 
        sideMenuState={sideMenuState} 
        onClick={closeSideMenu()}
        onOpen={openSideMenu()}
        onClose={closeSideMenu()}
      />
    </>
  );
}